export default __webpack_public_path__ + "static/media/metrobus.59fb0a28.svg";